import React, { useEffect, useState } from "react";
import Breadcumb from "../../../components/common/Breadcumb";
import CategoryList from "./utils/category-list.json";
import { Link, useLoaderData, useLocation } from "react-router-dom";
import axios from "axios";
// import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";
import { fetchCmsData } from "../../../Redux/actions/cmsDataAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/common/Loader";
import { setCategorySlug } from "../../../Redux/actions/categoryAction";
import { Helmet } from "react-helmet";
const Music = () => {
  const location = useLocation();
  const musicCategoryList1 = CategoryList;
  const [musicCategoryList, setMusicCategoryList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ lannguagePrefix, setLanguagePrefix ] = useState('')
  const {t, i18n} = useTranslation(); 

  const language = i18n.language;
  const dispatch = useDispatch();
  const cmsData = useSelector((state) => state.cmsData);
  const musicCmsData = cmsData?.data?.cms?.[0];
  useEffect(() => {
    dispatch(fetchCmsData('music', 'en')); 
  }, [dispatch]);


  useEffect(()=>{
     if (language === 'en' || i18n.language==="en-GB") {
      setLanguagePrefix('')
     } else {
      setLanguagePrefix(`/${language}`)
     }
  },[language])



  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_KEY + "/api/get-category");
        setMusicCategoryList(response.data);
      } catch (err) {
        setError("Failed to fetch music categories");
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // Sort categories alphabetically by title (in English)
  const sortedCategories = musicCategoryList?.categories?.sort((a, b) => {
    return a?.title?.[language]?.localeCompare(b?.title?.[language]);
  });

  if (loading) return <Loader />;


  if (error) {
    return <div>{error}</div>;
  }

    return (
    <>
     <Helmet>
        <title>{musicCmsData?.meta_title?.[language] || 'Uses '}</title>
        <link rel="canonical" href={`${process.env.REACT_APP_URL_LINK}${location.pathname}`} />
        <meta property="og:title" content={`${musicCmsData?.meta_title?.[language]}`} />
        <meta name="description" content={musicCmsData?.meta_description?.[language] || 'Description'} />
        <meta property="og:url" content={`${process.env.REACT_APP_URL_LINK}${location?.pathname}`} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://newlegismusic.nodejsdapldevelopments.com/storage/distribution/images/meta_property_image/67658c2374de11734708259.png" />
      </Helmet>
      <Breadcumb path={"music"} />
      <div className="music-category-main">
        <div className="container">
          {/* title section */}
          <div className="music-top-title">
            <h1>{musicCmsData?.title?.[language]}</h1>
            <div dangerouslySetInnerHTML={{__html:musicCmsData?.subheading?.[language]}}/>
            <p>
            </p>
          </div>
          {/* musin category list section  */}
          <div className="music-cat-list">
      {musicCategoryList?.success ? (
        sortedCategories?.length > 0 ? (
          sortedCategories.map((res, i) =>{ 
            return(
            <div key={i} className="music-cat-block">
              <Link to={`/music/${res?.slug?.[language]}`}>
                <img src={res?.image === null ? "/assets/img/no-image.jpg" : res?.full_image_url } alt={res?.title?.[language]} />
                <h4>{res?.title?.[language]}</h4>
              </Link>
            </div>
          )})
        ) : (
          <div>{t('music_No')}</div>
        )
      ) : (
        <div>{t('music_Empty')}</div>
      )}
    </div>

          {/* Viewall button */}
          <div className="view-all text-center">
            <Link to={`${lannguagePrefix}/all`} className="btn btn-secondary">
              {t('music_View')}
            </Link>
          </div>
          {/* music contant */}
          <div className="music-content-info">
        <div className="info-block">
          {/* <h3>{t('music_Background')}</h3> */}
          <div dangerouslySetInnerHTML={{__html:musicCmsData?.description?.[language]}}/>
        </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Music;
